import dayjs from "dayjs";
import { constants } from "services/constants";
import get from "lodash/get";
import time from "../time";
import config from "config";
import {
	getReportExtraDateRange,
	hasReportSidebarFilters,
	REPORT_DISHES_SIDEBAR_KEYS,
	REPORT_LIST_SORT,
	REPORT_ORDERS_SIDEBAR_KEYS
} from "./reportDateRange";

const getComingStatus = (status, tr) => {
	switch (status) {
		case 0:
			return { color: "gray", label: tr("Черновик") };
		case 1:
			return { color: "orange", label: tr("Ожидание") };
		case 2:
			return { color: "green", label: tr("принято") };
		default:
			return { color: "red", label: tr("#ошибка") };
	}
};

const getPromoStatus = (status, tr) => {
	switch (status) {
		case 0:
			return { color: "gray", label: tr("Черновик") };
		case 1:
			return { color: "green", label: tr("Активный") };
		case 2:
			return { color: "orange", label: tr("Приостановлен") };
		case 3:
			return { color: "red", label: tr("Законченный") };
		default:
			return { color: "red", label: tr("#ошибка") };
	}
};

const getSmsStatus = (status, tr) => {
	switch (status) {
		case 0:
			return { color: "gray", label: tr("Черновик") };
		case 1:
			return { color: "green", label: tr("Завершен") };
		case 2:
			return { color: "red", label: tr("Не удалось") };
		case 4:
			return { color: "blue", label: tr("Новый") };
		default:
			return { color: "red", label: tr("#ошибка") };
	}
};

const getViewSmsStatus = (status, tr) => {
	switch (status) {
		case 0:
			return { color: "blue", label: tr("Новый") };
		case 1:
			return { color: "green", label: tr("Отправлен") };
		case 2:
			return { color: "red", label: tr("Не удалось") };
		default:
			return { color: "red", label: tr("#ошибка") };
	}
};

const getPaymentType = (status, tr) => {
	switch (status) {
		case 1:
			return tr("Закуп");
		case 2:
			return tr("Продаж");
		default:
			return tr("Не указон");
	}
};

const getStatus = (status, tr) => {
	switch (status) {
		case 1:
			return { color: "green", label: tr("#активно") };
		case 0:
			return { color: "red", label: tr("#не активно") };
		default:
			return { color: "red", label: tr("#ошибка") };
	}
};

const getStatusUser = (status, tr) => {
	switch (status) {
		case 10:
			return { color: "green", label: tr("#активно") };
		case 1:
			return { color: "orange", label: tr("#не подтверждено") };
		case 0:
			return { color: "red", label: tr("#не активно") };
		default:
			return { color: "red", label: tr("#ошибка") };
	}
};

const getProductName = (row) => {
	if (!row || typeof row !== "object") return "";

	const name = get(row, "name", "");
	const options = get(row, "options", []);

	const safeName = typeof name === "string" ? name : "";

	if (!Array.isArray(options) || options.length === 0) {
		return safeName;
	}

	const optionNames = options
		.map((opt) => get(opt, "option_item.name", ""))
		.filter((v) => typeof v === "string" && v.trim() !== "");

	if (optionNames.length === 0) {
		return safeName;
	}

	return `${safeName} / ${optionNames.join(" / ")}`;
};

const getOrderStatus = (status, tr) => {
	switch (status) {
		case 1:
			return { color: "green", label: tr("Завершен") };
		case 0:
			return { color: "blue", label: tr("Новый") };
		case 2:
			return { color: "red", label: tr("Отменено") };
		case 3:
			return { color: "red", label: tr("Возврат") };
		default:
			return { color: "red", label: tr("#ошибка") };
	}
};

const getOrderType = (type, tr) => {
	switch (type) {
		case config.ORDER_TYPE_DELIVERY:
			return tr("Доставка");
		// case config.ORDER_TYPE_ON_TABLE:
		// 	return tr("На стол");
		case config.ORDER_TYPE_TAKEAWAY:
			return tr("На вынос");
		case config.ORDER_TYPE_ONLINE:
			return tr("Онлайн");
		case config.ORDER_TYPE_SALE:
			return tr("Продажа");
		default:
			return "";
	}
};

// Roʻyxatlar – funksiyaga aylantirildi, tr ni ichkarida qoʻllash uchun
const orderStatus = tr => [
	{ label: tr("Черновик"), value: "0" },
	{ label: tr("Новый"), value: "1" },
	{ label: tr("Завершен"), value: "20" },
	{ label: tr("Отменено"), value: "30" }
];

const orderTypes = tr => [
	// { label: tr("На стол"), value: "has_on_table" },
	{ label: tr("Заказы"), value: "has_takeaway" },
	{ label: tr("Доставка"), value: "has_delivery" },
	{ label: tr("Телеграм бот"), value: "has_telegram_bot" }
];

const orderTypesList = tr => [
	// { label: tr("На стол"), value: config.ORDER_TYPE_ON_TABLE },
	{ label: tr("Заказы"), value: config.ORDER_TYPE_TAKEAWAY },
	{ label: tr("Доставка"), value: config.ORDER_TYPE_DELIVERY },
	{ label: tr("Телеграм бот"), value: config.ORDER_TYPE_ONLINE }
];

const getUserRole = (role, tr) => {
	switch (role) {
		case "owner":
			return tr("Владелец");
		case "manager":
			return tr("Менеджер");
		case "warehouse":
			return tr("Завсклад");
		case "cashier":
			return tr("Кассир");
		case "kitchener":
			return tr("Другие сотрудники");
		case "waiter":
			return tr("Агент");
		case "employee":
			return tr("Работник");
		case "mono":
			return tr("Моноблок");
		case "provider":
			return tr("Поставщик");
		default:
			return "";
	}
};

const getUserType = (type, tr) => {
	switch (type) {
		case 1:
			return tr("Сотрудник");
		case 2:
			return tr("Поставщик");
		case 3:
			return tr("Клиент");
		case 4:
			return tr("Другие");
		default:
			return tr("");
	}
};

// ---------------- Misc helpers ----------------
const getMonths = (start, end) =>
	Array.from({ length: end.diff(start, "month") + 1 }).map((_, index) =>
		dayjs(start)
			.add(index, "month")
			.format("MM.YYYY")
	);

const isEnableLang = lang => {
	switch (lang) {
		case "ru":
			return true;
		case "uz":
			return true;
		default:
			return false;
	}
};

const stringToCode = element => {
	const content = element.textContent;
	function toNode(iframeString) {
		const div = document.createElement("div");
		div.innerHTML = iframeString;
		return div;
	}
	const parent = element.parentNode;
	const childOembed = parent.querySelector("code");
	childOembed.replaceWith(toNode(content));
};

const formatDate = (date, format) => {
	let dt = new Date(date);
	let month = ("00" + (dt.getMonth() + 1)).slice(-2);
	let day = ("00" + dt.getDate()).slice(-2);
	let year = dt.getFullYear();
	let hours = ("00" + dt.getHours()).slice(-2);
	let minutes = ("00" + dt.getMinutes()).slice(-2);
	let seconds = ("00" + dt.getSeconds()).slice(-2);

	switch (format) {
		case "DD-MM-YYYY":
			return day + "-" + month + "-" + year;
		case "DD.MM.YYYY / HH:mm:ss":
			return `${day}.${month}.${year} / ${hours}:${minutes}:${seconds}`;
		case "DD/MM/YYYY HH:mm:ss":
			return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
		case "DD.MM.YYYY / HH:mm":
			return `${day}.${month}.${year} / ${hours}:${minutes}`;
		case "HH:mm / DD.MM.YYYY":
			return `${hours}:${minutes} / ${day}.${month}.${year}`;
		case "HH:mm":
			return `${hours}:${minutes}`;
		default:
			return `${day}.${month}.${year}`;
	}
};

const formatTimestamp = (date, format) => {
	if (date.toString().length > 10) {
		return dayjs(date).format(format)
	} else {
		return dayjs(date * 1000).format(format)
	}
}

function isFloat(n) {
	return Number(n) === n && Number(n) % 1 !== 0;
}

function returnFloatWithFixedAndIntegerAsIs(n, toFixedPart = 2) {
	if (isFloat(n)) return n.toFixed(toFixedPart);
	return n;
}

function convertToReadable(number, fixedRoom = 2) {
	number = Number(number);
	if (fixedRoom > 0) {
		if (String(number).includes(".")) {
			number = number.toFixed(fixedRoom);
		}
	} else {
		number = Math.round(number);
	}
	function _isFloat(n) {
		return Number(n) === n && n % 1 !== 0;
	}
	let newValue;
	if (_isFloat(Number(number))) {
		newValue = number.toString().split(".");
		newValue[0] = newValue[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
		newValue = newValue.join(".");
	} else {
		newValue = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
	}
	return newValue;
}

function validateIsEmpty(value) {
	let error;
	if (!value || /^\s*$/.test(value)) {
		error = "Required";
	}
	return error;
}

const isLetter = value => {
	return (
		(value.charCodeAt(0) >= 97 && value.charCodeAt(0) <= 122) ||
		(value.charCodeAt(0) >= 65 && value.charCodeAt(0) <= 90)
	);
};

const checkLetter = value => {
	return (
		(value.charCodeAt(0) >= 97 && value.charCodeAt(0) <= 122) ||
		(value.charCodeAt(0) >= 65 && value.charCodeAt(0) <= 90) ||
		value.charCodeAt(0) === 46
	);
};

const checkNumber = value => {
	if (value) {
		if (typeof value !== "number" && typeof value === "string") {
			return +value.replaceAll(" ", "");
		} else {
			return +value;
		}
	} else {
		return null;
	}
};

const getValue = value => {
	if (value) {
		let result;
		value = String(value);
		let lastChar = value.slice(-1);

		if (lastChar.charCodeAt(0) !== 46) {
			if (!isLetter(lastChar)) {
				result = value
					? Number(value.replaceAll(" ", ""))
						.toFixed(1)
						.replace(/\d(?=(\d{3})+\.)/g, "$& ")
						.replaceAll(".0", "")
					: "";
			}
		} else {
			result = value
				? Number(value.replaceAll(" ", ""))
					.toFixed(1)
					.replace(/\d(?=(\d{3})+\.)/g, "$& ")
					.replaceAll(".0", ".")
				: "";
		}
		if (value.toString().includes(".") && !checkLetter(lastChar)) {
			result = value;
		}
		if (result === "Infinity" || result === "NaN") {
			result = null;
		}
		return result;
	}
};

const getDaysBetweenDates = (startDate, endDate, format = "YYYY-MM-DD") => {
	const now = startDate.clone(),
		dates = [];
	while (now.isSameOrBefore(endDate)) {
		dates.push(now.format(format));
		now.add(1, "days");
	}
	return dates;
};

const getGroupType = (groupType, tr) => {
	if (groupType === constants.GROUP_TYPE_CATEGORY) return tr("категорий");
	else if (groupType === constants.GROUP_TYPE_PRODUCT) return tr("продуктов");
	else if (groupType === constants.GROUP_TYPE_INVENTORY) return tr("инвентаря");
};

const getStorageType = storageType => {
	const found = constants.storageTypes.find(item => item.value === storageType);
	return found ? found.label : "";
};

// old function
// const formatNumber = (number) => {
// 	return number == 0 ? number : number && typeof (number) == "string" && number.includes(".") ? Number(number).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : typeof (number) == "string" ? Number(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : !number ? " " : number !== null && number.toString().includes(".") ? number.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : number !== null && number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : " ";
// };

// new function
const formatNumber = (value) => {
	if (value === 0) return "0";

	if (
		value === null ||
		value === undefined ||
		value === "" ||
		typeof value === "boolean"
	) {
		return " ";
	}

	const normalizedValue = String(value).replace(/\s/g, "").replace(",", ".");
	const num = Number(normalizedValue);
	if (Number.isNaN(num)) return " ";

	const [intPartRaw, decimalPartRaw] = normalizedValue.split(".");

	const intPart = intPartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

	if (!decimalPartRaw) {
		return intPart;
	}

	// Rounding yo'q: faqat nuqtadan keyingi dastlabki 2 ta raqam olinadi.
	const decimalPart = decimalPartRaw.slice(0, 2).replace(/0+$/, "");

	return decimalPart ? `${intPart}.${decimalPart}` : intPart;
};

// Oylar/choraklar – o‘zgarishsiz qoldi (i18n uchun tashqi mapping ishlatyapsiz)
const months = [
	{
		id: 1,
		month_oz: "Январ",
		month_uz: "Yanvar",
		month_ru: "Январь",
		month_en: "January"
	},
	{
		id: 2,
		month_oz: "Феврал",
		month_uz: "Fevral",
		month_ru: "Февраль",
		month_en: "February"
	},
	{
		id: 3,
		month_oz: "Март",
		month_uz: "Mart",
		month_ru: "Марть",
		month_en: "March"
	},
	{
		id: 4,
		month_oz: "Апрел",
		month_uz: "Aprel",
		month_ru: "Апрель",
		month_en: "Aprel"
	},
	{ id: 5, month_oz: "Май", month_uz: "May", month_ru: "Май", month_en: "May" },
	{
		id: 6,
		month_oz: "Июн",
		month_uz: "Iyun",
		month_ru: "Июнь",
		month_en: "June"
	},
	{
		id: 7,
		month_oz: "Июл",
		month_uz: "Iyul",
		month_ru: "Июль",
		month_en: "July"
	},
	{
		id: 8,
		month_oz: "Август",
		month_uz: "Avgust",
		month_ru: "Августь",
		month_en: "August"
	},
	{
		id: 9,
		month_oz: "Сентябр",
		month_uz: "Sentabr",
		month_ru: "Сентябрь",
		month_en: "September"
	},
	{
		id: 10,
		month_oz: "Октябр",
		month_uz: "Oktabr",
		month_ru: "Октябрь",
		month_en: "October"
	},
	{
		id: 11,
		month_oz: "Ноябр",
		month_uz: "Noyabr",
		month_ru: "Ноябрь",
		month_en: "November"
	},
	{
		id: 12,
		month_oz: "Декабр",
		month_uz: "Dekabr",
		month_ru: "Декабрь",
		month_en: "December"
	}
];

const quarters = [
	{ id: 1, title: "I чорак" },
	{ id: 2, title: "II чорак" },
	{ id: 3, title: "III чорак" },
	{ id: 4, title: "IV чорак" }
];

const getPeriodDateLabel = ({ date, period, tr }) => {
	if (period === "month") {
		const month = months.find(m => m.id === Number(date));
		return tr(get(month, "month_ru"));
	}
	if (period === "quarter") {
		const quarter = quarters.find(q => q.id === Number(date));
		return tr(get(quarter, "title"));
	}
	if (period === "week") {
		const a = time.to(
			dayjs()
				.dayOfYear((Number(date) + 1) * 7)
				.startOf("week")
				.unix()
		);
		const b = time.to(
			dayjs()
				.dayOfYear((Number(date) + 1) * 7)
				.endOf("week")
				.unix()
		);
		return a + " - " + b;
	}
	if (period === "doy") {
		return time.to(
			dayjs()
				.dayOfYear(Number(date) + 1)
				.unix()
		);
	}
};

const getCategoryLabelByType = (type, tr) => {
	switch (type) {
		case config.CATEGORY_MATERIAL:
			return tr("Категория материалов");
		case config.CATEGORY_PRODUCT:
			return tr("Категория реализации");
		case config.CATEGORY_HALF_FINISHED:
			return tr("Категория полуфабрикатов");
		case config.CATEGORY_FINISHED:
			return tr("Категория готовый продуктов");
		case config.CATEGORY_DISH:
			return tr("Категория блюд");
		case config.CATEGORY_STORE:
			return tr("Категория ZIM STORE");
		default:
			return "-";
	}
};

const getStorageLabelByType = (type, tr) => {
	switch (type) {
		case config.CATEGORY_MATERIAL:
			return tr("Сырьё");
		case config.CATEGORY_PRODUCT:
			return tr("Реализация");
		case config.CATEGORY_HALF_FINISHED:
			return tr("Полуфабрикат");
		case config.CATEGORY_FINISHED:
			return tr("Готовый продуктов");
		case config.CATEGORY_DISH:
			return tr("Продукт");
		default:
			return "-";
	}
};

const getCurrencyLabel = (currencyCode, tr) => {
	switch (currencyCode) {
		case "uzs":
			return tr("сум");
		case "kzt":
			return tr("тенге");
		case "aed":
			return tr("дирхам");
		case "tjs":
			return tr("сомони");
		default:
			return tr("сум");
	}
};

function hasRolePermission(getMeOrRoles, roleName, permission, mapOverride) {
	const roles = Array.isArray(getMeOrRoles)
		? getMeOrRoles
		: getMeOrRoles && Array.isArray(getMeOrRoles.roles)
			? getMeOrRoles.roles
			: [];

	if (!roles.length) return false;

	const defaultMap = {
		create: [1, "create"],
		read: [2, "read"],
		update: [3, "update"],
		delete: [4, "delete"]
	};
	const map = Object.assign({}, defaultMap, mapOverride || {});

	const wanted = (map[permission] || [permission]).map(v =>
		typeof v === "string" ? v.toLowerCase() : v
	);

	const target = String(roleName).toLowerCase();
	const aliases = new Set([
		target,
		target.endsWith("s") ? target.slice(0, -1) : target + "s"
	]);

	return roles.some(r => {
		const roleName = String(r.role || r.name || "").toLowerCase();
		if (!aliases.has(roleName)) return false;

		const perms = Array.isArray(r.permissions) ? r.permissions : [];
		return perms.some(p => {
			const val = typeof p === "string" ? p.toLowerCase() : p;
			return wanted.includes(val);
		});
	});
}

function formatDateISO8601(value, format = "dd.mm.yyyy") {
	try {
		if (!value) return "";

		// ISO, Date, timestamp — hammasini qabul qiladi
		const date =
			value instanceof Date
				? value
				: typeof value === "number"
					? new Date(value)
					: new Date(String(value));

		if (isNaN(date.getTime())) return "";

		const pad = (n) => String(n).padStart(2, "0");

		const map = {
			yyyy: date.getFullYear(),
			mm: pad(date.getMonth() + 1), // month
			dd: pad(date.getDate()),
			HH: pad(date.getHours()),
			MM: pad(date.getMinutes()),  // minutes
			ss: pad(date.getSeconds()),
		};

		return format.replace(/yyyy|mm|dd|HH|MM|ss/g, (token) => map[token]);
	} catch {
		return "";
	}
}

function formatPhoneNumber(input) {
	if (input === null || input === undefined || (typeof input === 'number' && isNaN(input))) {
		return "Noto'g'ri format";
	}

	const cleaned = typeof input === "string"
		? input.replace(/\D/g, '')
		: input.toString().replace(/\D/g, '');

	if (!/^\d+$/.test(cleaned)) {
		return "Noto'g'ri format";
	}

	const normalized = cleaned.startsWith('998') ? cleaned : '998' + cleaned;

	if (normalized.length !== 12) {
		return "Noto'g'ri format";
	}

	return `+${normalized.slice(0, 3)} (${normalized.slice(3, 5)}) ${normalized.slice(5, 8)}-${normalized.slice(8, 10)}-${normalized.slice(10, 12)}`;
}

export default {
	getCurrencyLabel,
	getStorageLabelByType,
	getCategoryLabelByType,
	getOrderType,
	getPeriodDateLabel,
	getComingStatus,
	getPromoStatus,
	getStorageType,
	getGroupType,
	getMonths,
	getUserRole,
	getUserType,
	getDaysBetweenDates,
	isEnableLang,
	formatDate,
	formatTimestamp,
	stringToCode,
	getStatus,
	getStatusUser,
	getPaymentType,
	convertToReadable,
	validateIsEmpty,
	getValue,
	checkNumber,
	getOrderStatus,
	orderStatus,
	orderTypes,
	orderTypesList,
	isFloat,
	returnFloatWithFixedAndIntegerAsIs,
	hasRolePermission,
	formatNumber,
	getProductName,
	formatDateISO8601,
	formatPhoneNumber,
	getSmsStatus,
	getViewSmsStatus,
	getReportExtraDateRange,
	hasReportSidebarFilters,
	REPORT_DISHES_SIDEBAR_KEYS,
	REPORT_LIST_SORT,
	REPORT_ORDERS_SIDEBAR_KEYS
};
